// extracted by mini-css-extract-plugin
module.exports = {"root":"_2xtmD","avatar":"_3T4H6"};